export default "__VITE_ASSET__Came22ei__"